import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#194173',        // Bleu principal de votre logo
        secondary: '#f68d3b',      // Orange de votre logo
        accent: '#4CAF50',         // Vert pour les actions positives
        error: '#F44336',          // Rouge pour les erreurs
        warning: '#FF9800',        // Orange pour les avertissements
        info: '#2196F3',           // Bleu pour les informations
        success: '#4CAF50',        // Vert pour les succès
        background: '#FAFAFA',     // Arrière-plan principal
        surface: '#FFFFFF',        // Surface des cartes
        'surface-light': '#F5F5F5', // Surface claire
        'on-primary': '#FFFFFF',   // Texte sur fond primaire
        'on-secondary': '#FFFFFF', // Texte sur fond secondaire
      },
      dark: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        warning: '#FFB74D',
        info: '#2196F3',
        success: '#4CAF50',
        background: '#121212',
        surface: '#1E1E1E',
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  },
  options: {
    customProperties: true
  }
});
